module.exports = __webpack_public_path__ + "b17b7050a120a838f6502d3e87116a72.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/monkey.png
// module id = 514
// module chunks = 0